import { createTheme, alpha } from "@mui/material/styles";
import { brand, neutral, semantic, original, fontFamily, fontSize } from "app/theme/tokens";
import { components } from "app/theme/components";

/** The application's MUI theme — built only from ./tokens. */
export const appTheme = createTheme({
  palette: {
    mode: "light",
    // Original button colours: blue primary, orange secondary.
    primary: { light: "#5393ff", main: original.primaryBtn, dark: original.primaryBtnHover, contrastText: "#fff" },
    secondary: { light: "#ffc56b", main: original.secondaryBtn, dark: original.secondaryBtnHover, contrastText: original.secondaryBtnText },
    success: { main: semantic.success, contrastText: "#fff" },
    warning: { main: semantic.warning, contrastText: "#fff" },
    error: { main: semantic.error, contrastText: "#fff" },
    info: { main: semantic.info, contrastText: "#fff" },
    grey: neutral,
    text: { primary: neutral[800], secondary: neutral[500], disabled: neutral[400] },
    divider: neutral[200],
    background: { default: neutral[50], paper: neutral[0] },
    action: {
      hover: alpha(brand.tealDark, 0.06),
      selected: alpha(brand.tealDark, 0.1),
      focus: alpha(brand.tealDark, 0.12),
    },
  },
  shape: { borderRadius: 4 }, // sx borderRadius: 1 = 4px, 1.5 = 6px, 2 = 8px
  spacing: 8,
  typography: {
    fontFamily,
    fontSize: fontSize.md,
    htmlFontSize: 16,
    h1: { fontSize: 24, fontWeight: 700, lineHeight: 1.3 },
    h2: { fontSize: 22, fontWeight: 700, lineHeight: 1.3 },
    h3: { fontSize: 20, fontWeight: 600, lineHeight: 1.35 },
    h4: { fontSize: fontSize.xl, fontWeight: 600, lineHeight: 1.35 },
    h5: { fontSize: 16, fontWeight: 600, lineHeight: 1.4 },
    h6: { fontSize: fontSize.lg, fontWeight: 600, lineHeight: 1.4 },
    subtitle1: { fontSize: fontSize.md, fontWeight: 600 },
    subtitle2: { fontSize: fontSize.sm, fontWeight: 600 },
    body1: { fontSize: fontSize.md },
    body2: { fontSize: fontSize.sm },
    caption: { fontSize: fontSize.xs },
    overline: { fontSize: fontSize.xs, fontWeight: 600, letterSpacing: "0.06em" },
    button: { fontSize: fontSize.sm, fontWeight: 600, textTransform: "none" },
  },
  components,
});

export { default as tokens } from "app/theme/tokens";
export * from "app/theme/tokens";
export default appTheme;
